import classes from "./input_component.module.css";
const InputComponent = ({
  inputType,
  name,
  onChangeHandler,
  options,
  isDisabled,
  isRequired,
  inputPlaceholder,
  value,
  title="",
}) => {
  let OptionTags = null;

  if (options !== undefined) {
    OptionTags = options.map((option) => (
      <option key={option} value={option}>
        {option}
      </option>
    ));
  }

  return (
    <>
      <input
        className={classes.input}
        type={inputType}
        list="dataList"
        id={name}
        name={name}
        maxLength="500"
        onChange= {onChangeHandler} 
        disabled={isDisabled}
        required={isRequired}
        placeholder={inputPlaceholder}
        value={value}
        pattern=".*\S+.*" // Ensures at least one non-whitespace character
        title={title}
      />
      <datalist id="dataList">{OptionTags}</datalist>
    </>
  );
};

export default InputComponent;
